import React, { useEffect, useState } from 'react';
import { View, colors } from '@fairygodboss/ui';
import { AudioPlayerProvider } from './AudioPlayer/AudioPlayerProvider';
import { Player } from './AudioPlayer/Player';

export const AudioPlayer = ({ src }) => {
    const [mounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);
    return mounted ? (
        <AudioPlayerProvider src={src}>
            <View
                className="react-player"
                bottom={{ _: '0px', sm: 'inherit' }}
                position={{ _: 'fixed', sm: 'inherit' }}
                width={{ width: '100vw', sm: 'inherit' }}
                marginLeft={{ _: '-16px', sm: 'inherit' }}
                zIndex={{ _: '11', sm: 'inherit' }}
            >
                <Player />
            </View>
        </AudioPlayerProvider>
    ) : (
        <View
            backgroundColor={colors.secondary[70]}
            height="64px"
            display="flex"
            width="100%"
        />
    );
};

AudioPlayer.display = 'AudioPlayer';
